import { RootStoreState } from 'modules/root'

/**
 * 
 * @param state Select the current admin access token from the root store state.
 */

export const selectKnowledgeLibrary = (state: RootStoreState) => state.knowledgeLibrary.knowledgeLibrary
export const selectKnowledgeLibraryState = (state: RootStoreState) => state.knowledgeLibrary
